import {SVGProps} from 'react';

const Icon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="32"
        viewBox="0 0 32 32"
        width="32"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M8.5 29.5H23.5C25.1569 29.5 26.5 28.1569 26.5 26.5V10.9321C26.5 10.6563 26.3862 10.3928 26.1854 10.2039L18.2888 2.7718C18.1033 2.59721 17.8582 2.5 17.6034 2.5H8.5C6.84315 2.5 5.5 3.84315 5.5 5.5V26.5C5.5 28.1569 6.84315 29.5 8.5 29.5Z"
            fill="#DEDEDE"
            stroke="#818181"
            strokeWidth="1.5"
        />
        <rect fill="#3C3C3C" height="10" rx="2" width="21" x="2" y="17" />
        <path
            d="M17.5 2.5V10C17.5 10.5523 17.9477 11 18.5 11H26.5"
            stroke="#818181"
            strokeWidth="1.5"
        />
        <path
            d="M4 25.3413H5.61279V23.4824H6.70264C8.11768 23.4824 9.03174 22.6123 9.03174 21.2544V21.2456C9.03174 19.8877 8.11768 19 6.70264 19H4V25.3413ZM6.31592 20.2349C6.99707 20.2349 7.40137 20.5864 7.40137 21.2456V21.2544C7.40137 21.9136 6.99707 22.2695 6.31592 22.2695H5.61279V20.2349H6.31592Z"
            fill="#FDFDFD"
        />
        <path
            d="M10.018 25.3413H12.5932C14.5049 25.3413 15.6343 24.1592 15.6343 22.1333V22.1245C15.6343 20.1074 14.5049 19 12.5932 19H10.018V25.3413ZM11.6308 24.0405V20.3008H12.3823C13.3974 20.3008 13.9951 20.9424 13.9951 22.1289V22.1377C13.9951 23.4033 13.4326 24.0405 12.3823 24.0405H11.6308Z"
            fill="#FDFDFD"
        />
        <path
            d="M16.6865 25.3413H18.2993V22.9771H20.7558V21.7422H18.2993V20.2964H21.0019V19H16.6865V25.3413Z"
            fill="#FDFDFD"
        />
    </svg>
);

export default Icon;
